import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useGlobalContext } from "../GlobalContext";

const useReports = () => {
  const { baseurl, accessToken, token, AdminId, setIsUnauthorised } =
    useGlobalContext();

  const [loading, setLoading] = useState(false); // for analytics
  const [taskLoading, setTaskLoading] = useState(false); // for reports
  const [loadingDrivers, setLoadingDrivers] = useState(false);

  // ================= PACKKY DASHBOARD DATA =================
  const fetchPackkyData = async (
    fromDate,
    toDate,
    setRestaurantData,
    setDriverTaskAnalytics,
    setTaskStatusAnalytics,
  ) => {
    setLoading(true);
    try {
      const payload = { fromDate, toDate, adminId: AdminId };
      const config = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };

      const [res1, res2, res3] = await Promise.all([
        axios.post(
          `${baseurl}/api/Task/v1.0/getTaskAnalytics`,
          payload,
          config,
        ),
        axios.post(
          `${baseurl}/api/Driver/v1.0/getDriverAnalytics`,
          payload,
          config,
        ),
        axios.post(
          `${baseurl}/api/Task/v1.0/getTaskAnalyticsByStatus`,
          payload,
          config,
        ),
      ]);

      setRestaurantData(res1.data.data || []);
      setDriverTaskAnalytics(res2.data.data || []);
      setTaskStatusAnalytics(res3.data.data || []);
    } catch (err) {
      console.error("Error loading reports:", err);
      if (err?.response?.status === 401) setIsUnauthorised(true);
    } finally {
      setLoading(false);
    }
  };

  // ================= SINGLE DRIVER ANALYTICS =================
  const fetchDriverAnalytics = async (
    driverCode,
    fromDate,
    toDate,
    setAnalytics,
  ) => {
    setLoading(true);
    try {
      const payload = {
        adminId: AdminId,
        driverCode, // ✅ SAME AS OLD FILE
        fromDate,
        toDate,
      };

      const res = await axios.post(
        `${baseurl}/api/Driver/v2.0/getDriverAnalytics`, // ✅ OLD WORKING API
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`, // ✅ SAME AS OLD FILE
          },
        },
      );

      setAnalytics(res.data?.data || null); // ✅ SAME SHAPE AS OLD FILE
    } catch (error) {
      console.error("Analytics API Error:", error);
      if (error?.response?.status === 401) {
        setIsUnauthorised(true);
      }
    } finally {
      setLoading(false);
    }
  };

  // ================= SINGLE DRIVER REPORTS =================
  const fetchDriverReports = async (
    driverCode,
    fromDate,
    toDate,
    setReports,
  ) => {
    setTaskLoading(true);
    try {
      const payload = {
        adminId: AdminId,
        driverCode, 
        fromDate,
        toDate,
      };

      const res = await axios.post(
        `${baseurl}/api/Task/v1.0/getDriverReport`,
        payload,
        {
          headers: { Authorization: `Basic ${token}` }, 
        },
      );

      if (res?.data?.responseCode === "00") {
        setReports(res.data.data.reverse() || []);
      } else {
        setReports([]);
      }
    } catch (err) {
      console.error("Driver reports error:", err);
      setReports([]);
    } finally {
      setTaskLoading(false);
    }
  };

  return {
    fetchPackkyData,
    fetchDriverAnalytics,
    fetchDriverReports,
    loading,
    taskLoading,
    loadingDrivers,
  };
};

export default useReports;
